import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
  } from "recharts";
  
  export default function SingleBarChart({ data }) {

    const CustomTooltip = ({ active, payload, label }) => {

      // console.log(payload);
      if (active && payload && payload.length) {
        return (
          <div className="custom-tooltip">
            <span style={{display: 'block'}}>{`${label}: ${payload[0]?.value?.toLocaleString('en-IN')}`}</span>
            {/* <span style={{display: 'block'}}>{`${label}`}</span> */}
            {/* <span style={{display: 'block'}}>{`${payload[0]?.payload?.data1Lable}: ${payload[0]?.value}`}</span> */}
            {/* <p className="intro">{getIntroOfPage(label)}</p>
            <p className="desc">Anything you want can be displayed here.</p> */}
          </div>
        );
      }
    
      return null;
    };

    const CustomLegend = (props) => {
      const {payload} = props;
      return <div className="bar-legend">Timestamp</div>
    }

    return (
      <ResponsiveContainer width="100%" height={400}>
        {console.log(data)}
        <BarChart
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="data1" />
          <YAxis />
          {/* <Tooltip /> */}
          <Tooltip content={<CustomTooltip />} cursor={{fill: 'transparent'}} />
          <Legend content={CustomLegend}/>
          <Bar dataKey="data1Lable" fill="#8884d8" />
          {/* <Bar dataKey="uv" fill="#82ca9d" /> */}
        </BarChart>
      </ResponsiveContainer>
    );
  }